import HBIcon from "@/components/HBIcon";
import { When } from "react-if";
import styles from "./index.module.less";

export default function HBPageTitle({
  title,
  backAction,
  actions,
}: {
  title: string;
  backAction?: () => void;
  actions?: React.ReactNode;
}) {
  return (
    <div className={styles.pageTitle}>
      {/* 返回按钮 */}
      <When condition={!!backAction}>
        <a className={styles.backBtn} onClick={backAction}>
          <HBIcon type="ic_arrowThinLeft" />
        </a>
      </When>

      {/* 标题 */}
      <div className={styles.title}>{title}</div>

      {/* 操作按钮 */}
      <When condition={!!actions}>
        <div className={styles.actions}>{actions}</div>
      </When>
    </div>
  );
}
